import React from 'react';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { getListingBids } from '../../util/dataExtractor';
import Modal from '../Modal/Modal';
import { isArrayLength, maskName } from '../../util/genericHelpers';
import css from './OrderPanel.module.css';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import moment from 'moment';
import { PrimaryButton } from '../Button/Button';
const { Money } = sdkTypes;

const ViewBidsModal = ({ isOpen, onClose, listing }) => {
  const listingBids = getListingBids(listing);
  const dispatch = useDispatch();
  const intl = useIntl();

  return (
    <Modal
      id="viewBid.modal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={(componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling))
      }
      modalTitle={intl.formatMessage({
        id: 'OrderPanel.viewBidModal.title',
      })}
    >
      {isArrayLength(listingBids) ? (
        <div className={css.currentBids}>
          {listingBids.map(bid => {
            const biddingAmount = new Money(bid?.bidAmount, bid?.bidCurrency);
            const biddrName = maskName(bid?.biddrName);
            const bidPlacedAt = bid?.bidPlacedAt;
            const formattedBiddingAmount = formatMoney(intl, biddingAmount);

            return (
              <div className={css.bidBlock}>
                <div className={css.bidInfo} key={bidPlacedAt}>
                  <h2>{biddrName && biddrName}</h2>
                  <div className={css.bidTime}>
                    <span>{formattedBiddingAmount && formattedBiddingAmount}</span>
                    <span>{bidPlacedAt && moment.unix(bidPlacedAt).format('lll')}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className={css.noBids}>
          {intl.formatMessage({ id: 'OrderPanel.viewBidModal.noBids' })}
        </div>
      )}
      {/* <div className={css.bidNowBtn}>
        <PrimaryButton>Bid now</PrimaryButton>
      </div> */}
    </Modal>
  );
};

export default ViewBidsModal;
